// Icônes SVG custom (style lucide : trait, 24x24) pour véhicules et engins de chantier
// non couverts par lucide-react. API compatible : { size, color, strokeWidth, className }.
const Svg = ({ size = 24, color = "currentColor", strokeWidth = 2, className, children, ...p }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24"
    fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"
    className={className} {...p}>{children}</svg>
);

export const CitadineIcon = (p) => (
  <Svg {...p}>
    <path d="M4 14l1.6-3.7A2 2 0 0 1 7.4 9h6.8a2 2 0 0 1 1.8 1.1L18 14" />
    <path d="M3 14h18v2.5a1 1 0 0 1-1 1h-.6a1.9 1.9 0 0 1-3.8 0H9.2a1.9 1.9 0 0 1-3.8 0H4a1 1 0 0 1-1-1z" />
    <path d="M8.5 10.5v3M13.5 10.5v3" />
  </Svg>
);

export const PickupIcon = (p) => (
  <Svg {...p}>
    <path d="M3 16v-3h6" />
    <path d="M9 16V8h4l3.2 3.2V16" />
    <path d="M9 13h7.2" />
    <path d="M3 16h1M11 16h4.5M20 16h1" />
    <circle cx="7" cy="17" r="1.9" />
    <circle cx="17.5" cy="17" r="1.9" />
  </Svg>
);

export const FourgonMoyenIcon = (p) => (
  <Svg {...p}>
    <path d="M3 16V8h10l4 3.5V16" />
    <path d="M13 8v8" />
    <path d="M3 16h1M9 16h5.5M19 16h1" />
    <circle cx="7" cy="17" r="1.9" />
    <circle cx="16.5" cy="17" r="1.9" />
  </Svg>
);

export const FourgonGrandIcon = (p) => (
  <Svg {...p}>
    <rect x="3" y="6" width="12" height="10" rx="0.5" />
    <path d="M15 9h3.2L21 12.5V16h-6" />
    <path d="M3 16h1M9 16h6M20 16h1" />
    <circle cx="7" cy="17.5" r="1.9" />
    <circle cx="18" cy="17.5" r="1.9" />
  </Svg>
);

export const GenerateurIcon = (p) => (
  <Svg {...p}>
    <rect x="3" y="7" width="18" height="11" rx="1.5" />
    <path d="M3 11h18" />
    <path d="M7 7V5.5h4V7" />
    <path d="M12.5 12l-2.2 3.2H12l-1 2.8 3.2-3.8H12z" />
  </Svg>
);

export const SoudeurIcon = (p) => (
  <Svg {...p}>
    <rect x="3" y="6" width="11" height="11" rx="1" />
    <path d="M5.5 9h6M5.5 12h6M5.5 15h3" />
    <path d="M14 8.5l3.5 2.5-2 .8 3 2.2" />
    <path d="M20.5 8l-1 2 2 .3z" />
  </Svg>
);

export const MiniPelleIcon = (p) => (
  <Svg {...p}>
    <rect x="3" y="15" width="8" height="3" rx="1.5" />
    <path d="M4.5 18h5" />
    <rect x="5" y="11" width="5" height="4" rx="0.8" />
    <path d="M10 12.5l3.5-1.5 2 1" />
    <path d="M15.5 12l1.5 2.2-2.4.6z" />
  </Svg>
);

export const PelleHydrauliqueIcon = (p) => (
  <Svg {...p}>
    <rect x="2.5" y="15.5" width="9" height="3" rx="1.5" />
    <path d="M4 18.5h6" />
    <rect x="4.5" y="10" width="6" height="5.5" rx="0.8" />
    <path d="M10.5 11l5-2 2.5 1.5" />
    <path d="M18 10.5l2 3.2-3.4.7z" />
  </Svg>
);

export const CompacteurIcon = (p) => (
  <Svg {...p}>
    <circle cx="6.5" cy="15" r="3.3" />
    <circle cx="6.5" cy="15" r="0.6" />
    <circle cx="17.5" cy="16.5" r="2" />
    <rect x="9.5" y="8" width="6.5" height="5" rx="0.8" />
    <path d="M9.8 13H16a2 2 0 0 1 2 2" />
  </Svg>
);

export const DumperIcon = (p) => (
  <Svg {...p}>
    <path d="M2.5 14l2.2-5h4.3l2.5 5" />
    <path d="M2.5 14h9" />
    <rect x="12" y="8.5" width="6" height="5.5" rx="0.8" />
    <circle cx="7" cy="17" r="2" />
    <circle cx="16" cy="17" r="2" />
    <path d="M2.5 17h2.5M9 17h5M18 17h1.5" />
  </Svg>
);

export const ArticuleIcon = (p) => (
  <Svg {...p}>
    <path d="M2.5 14V9.5h5l1 4.5" />
    <path d="M9 14l1.2-5H20l1 5" />
    <path d="M8.5 11.5h1.5" />
    <circle cx="6" cy="16.5" r="1.8" />
    <circle cx="12" cy="16.5" r="1.8" />
    <circle cx="18" cy="16.5" r="1.8" />
  </Svg>
);

// --- Famille « catégories » cohérente (originale, style lucide 24x24) ----------------------------
// Ajouts pour combler les manques sémantiques / de registre. AUCUN actif tiers copié.

// Utilitaire = fourgon tôlé (remplace l'ancien lucide « Caravan » sémantiquement inadapté).
export const UtilitaireIcon = (p) => (
  <Svg {...p}>
    <path d="M3 7h11v9H3z" />
    <path d="M14 10h3.2l2.3 2.6V16H14z" />
    <path d="M3 16h1.2M9 16h6.2M19.8 16H21" />
    <circle cx="7" cy="17.3" r="1.7" />
    <circle cx="17.5" cy="17.3" r="1.7" />
  </Svg>
);

// Moto (remplace l'ancien lucide « Bike » = vélo).
export const MotoIcon = (p) => (
  <Svg {...p}>
    <circle cx="5.5" cy="16" r="3" />
    <circle cx="18.5" cy="16" r="3" />
    <path d="M5.5 16l3-5h4l2 3h3.9" />
    <path d="M8.5 11h5" />
    <path d="M14.5 8.5h2.3l1 2.5" />
  </Svg>
);

// Chargeuse sur pneus (godet avant) — catégorie absente jusqu'ici.
export const ChargeuseIcon = (p) => (
  <Svg {...p}>
    <path d="M3 13.5l3.5-2 2.5 1.5" />
    <path d="M2.5 13.5l-.5 3h3" />
    <rect x="8.5" y="8.5" width="6.5" height="6" rx="0.8" />
    <path d="M15 11h3.5a2 2 0 0 1 2 2v1.5" />
    <circle cx="7" cy="17" r="2" />
    <circle cx="17" cy="17" r="2" />
  </Svg>
);

// Engin de terrassement (bouteur/chenilles) — catégorie générique « engin ».
export const EnginIcon = (p) => (
  <Svg {...p}>
    <rect x="7" y="9" width="7" height="4.5" rx="0.8" />
    <path d="M14 10.5h3.5l1.5 3" />
    <path d="M3 14l1.5-2.2 2 .8" />
    <rect x="3" y="15" width="16" height="3" rx="1.5" />
    <path d="M4.5 16.5h13" />
  </Svg>
);

// Matériel autonome (caisson/groupe mobile avec engrenage) — remplit la clé « equipment ».
export const MaterielIcon = (p) => (
  <Svg {...p}>
    <rect x="3" y="7" width="18" height="11" rx="1.5" />
    <path d="M3 11h8" />
    <circle cx="15.5" cy="13.5" r="2.2" />
    <path d="M15.5 10.6v-.9M15.5 17.3v-.9M12.6 13.5h-.9M19.3 13.5h-.9" />
  </Svg>
);
